import { Dialog, DialogContent, Typography, Box, Button } from '@mui/material';

interface LocationDeniedModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function LocationDeniedModal({
  open,
  onCancel,
  onConfirm,
}: LocationDeniedModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          width: 360,
          boxShadow: '0px 10px 30px rgba(0,0,0,0.2)',
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', p: 4 }}>
        {/* Title */}
        <Typography variant="h6" fontWeight={600} mb={1}>
          Oops!
        </Typography>

        {/* Message */}
        <Typography variant="body2" color="text.secondary" mb={3}>
          Location access is denied. Please enable location from the browser
          settings and try again.
        </Typography>

        {/* Buttons */}
        <Box display="flex" justifyContent="center" gap={2}>
          <Button
            variant="outlined"
            onClick={onCancel}
            sx={{
              minWidth: 100,
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              minWidth: 100,
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 500,
              backgroundColor: '#4F7FA2',
              '&:hover': {
                backgroundColor: '#446f8c',
              },
            }}
          >
            Okay
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
